import { render, staticRenderFns } from "./workerQueue.vue?vue&type=template&id=5b15e3c2&scoped=true&"
import script from "./workerQueue.vue?vue&type=script&lang=js&"
export * from "./workerQueue.vue?vue&type=script&lang=js&"
import style0 from "./workerQueue.vue?vue&type=style&index=0&id=5b15e3c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b15e3c2",
  null
  
)

export default component.exports